import script from "./collapse.vue?vue&type=script&setup=true&lang=ts"
export * from "./collapse.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__